import { ReportListItemData } from './report-base';

export class InCompleteReportUserListItem extends ReportListItemData {
  dateRegistered: Date;
  lastStepCompleted: number;
  clubfeepaymentplanID: number;
  nextStep: string;
  amount: number;
  fees: string;
  clubuserprogramfeeID: number;
}

export class InCompleteReport {
  totalIncompleteNumber: number;
  totalPotentialIncome: number;
  list: InCompleteReportUserListItem[];

  constructor(data: any = {}) {
    this.totalIncompleteNumber = +data.totalIncompleteNumber;
    this.totalPotentialIncome = +data.totalPotentialIncome;
    this.list = data.incompleteUserList ? data.incompleteUserList.map(l => new InCompleteReportUserListItem(l)) : [];
  }
}



// WEBPACK FOOTER //
// ./src/app/models/reports/in-complete-report.ts